import React, { useContext } from 'react'

export const PageContext = React.createContext({} as any)

export function usePageContext() {
  return useContext(PageContext)
}
